module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "posts clearfix"
  }, [_c('div', {
    staticClass: "news_block latest"
  }, [_c('h4', [_vm._v("POPULAR POSTS")]), _vm._v(" "), _c('ul', _vm._l((_vm.fetchedData), function(data) {
    return _c('li', [_c('span', [_c('router-link', {
      attrs: {
        "to": '/blog/' + data.attributes.slug
      }
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": data.attributes.medium_image,
        "width": "80",
        "height": "80",
        "alt": "earth"
      }
    })])], 1), _vm._v(" "), _c('div', {
      staticClass: "news_in col-xs-8"
    }, [_c('p', [_c('router-link', {
      attrs: {
        "to": '/blog/' + data.attributes.slug
      }
    }, [_vm._v(_vm._s(data.attributes.title))])], 1), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm._f("convertDate")(data.attributes.event_date)))])]), _vm._v(" "), _c('div', {
      staticClass: "clear"
    })])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78eba7e7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Popular.vue
// module id = 309
// module chunks = 1